"use client";

interface PopupMenuCriacaoProps {
  onAbrirIniciativa: () => void;
  onAbrirEpico: () => void;
  onAbrirTarefa: () => void;
  onFechar: () => void;
}

export function PopupMenuCriacao({ onAbrirIniciativa, onAbrirEpico, onAbrirTarefa, onFechar }: PopupMenuCriacaoProps) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-3xl p-6 max-w-sm w-full">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-slate-900">
            Adicionar
          </h2>
          <button
            type="button"
            onClick={onFechar}
            className="rounded-full p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100"
          >
            ✕
          </button>
        </div>

        <div className="space-y-3">
          <button
            type="button"
            onClick={onAbrirIniciativa}
            className="w-full flex items-center gap-3 rounded-2xl border border-indigo-200 bg-indigo-50 p-4 text-left transition hover:bg-indigo-100 hover:border-indigo-300"
          >
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-indigo-500">
              <span className="text-white text-lg">🎯</span>
            </div>
            <div>
              <div className="font-medium text-slate-900">Nova Iniciativa</div>
              <div className="text-sm text-slate-600">Objetivo estratégico de alto nível</div>
            </div>
          </button>

          <button
            type="button"
            onClick={onAbrirEpico}
            className="w-full flex items-center gap-3 rounded-2xl border border-purple-200 bg-purple-50 p-4 text-left transition hover:bg-purple-100 hover:border-purple-300"
          >
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-purple-500">
              <span className="text-white text-lg">📋</span>
            </div>
            <div>
              <div className="font-medium text-slate-900">Novo Épico</div>
              <div className="text-sm text-slate-600">Conjunto de entregáveis relacionados</div>
            </div>
          </button>

          <button
            type="button"
            onClick={onAbrirTarefa}
            className="w-full flex items-center gap-3 rounded-2xl border border-slate-200 bg-slate-50 p-4 text-left transition hover:bg-slate-100 hover:border-slate-300"
          >
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-slate-500">
              <span className="text-white text-lg">✅</span>
            </div>
            <div>
              <div className="font-medium text-slate-900">Nova Tarefa</div>
              <div className="text-sm text-slate-600">Ação específica e executável</div>
            </div>
          </button>
        </div>

        <div className="mt-6">
          <button
            type="button"
            onClick={onFechar}
            className="w-full rounded-full px-6 py-3 text-sm font-medium text-slate-600 border border-slate-200 hover:bg-slate-50"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
